import { Progress, Stack, Text } from '@mantine/core';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import type { BulkClaimGenerationJobStatusRes } from '@dealstack/shared/lib/backendClient';
import {
	generationProgressPercent,
	isBulkClaimGenerationJobTerminal,
} from './BulkClaimOnBehalf.utils';

interface Props {
	state: BulkClaimGenerationJobStatusRes;
}

/**
 * Live progress for the async bulk-claim document generation job: "Preparing
 * documents… X of N" plus a bar while running, and a failed count on completion.
 */
export const BulkClaimGenerationProgress = ({ state }: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<Stack gap="xs">
			<Text size="sm">
				{tMipManage('documents_page.bulk_claim.generation_progress', {
					done: state.generated + state.failed,
					total: state.total,
				})}
			</Text>
			{!isBulkClaimGenerationJobTerminal(state.status) && (
				<Progress value={generationProgressPercent(state)} size="lg" animated />
			)}
			{state.failed > 0 && (
				<Text size="xs" c="red">
					{tMipManage('documents_page.bulk_claim.generation_failed', {
						failed: state.failed,
					})}
				</Text>
			)}
		</Stack>
	);
};
